import { ITranslations } from 'types/common';
import en from 'translations/en/script.json';
import pl from 'translations/pl/script.json';
import sl from 'translations/sl/script.json';
import { ScriptTransFields } from './types';

export const scriptTranslations: ITranslations<ScriptTransFields> = {
  name: 'script',
  en,
  pl,
  sl,
};
